<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-row>
          <b-col sm="4">
            <b-card>
              <div slot="header">
                <i class="fa fa-upload"></i> {{$t('str.import-two-wheel')}}
              </div>
              <div>
                <b-row>
                  <b-col sm="12">
                    <h4 style="margin-bottom:0;">{{$t('str.mass-data-importer')}}</h4>
                    <span>{{$t('str.import-data-from-excel-file')}}</span><br /><br />
                    <b-form @submit.prevent="importFile">
                      <b-row class="form-group">
                        <b-col>
                          <b-form-file id="import_file" name="import_file" accept=".xlsx" :plain="true"
                            v-model="addDataImport.import_file" v-validate="{required:true}"></b-form-file>
                          <small>{{$t('str.only-xlsx-is-allowed')}}</small>
                          <b-alert show variant="danger" v-if="errors.first('import_file')">
                            {{$t('str.please-upload-file')}}
                          </b-alert>
                        </b-col>
                      </b-row>
                      <b-row class="form-group">
                        <b-col>
                          <b-button type="submit" variant="primary" class="px-4" :disabled="runningProcess"><i
                              v-if="runningProcess" class="fa fa-spinner fa-spin"></i>{{$t('str.import')}}</b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
          <b-col sm="4">
            <b-card>
              <div slot="header">
                <i class="fa fa-upload"></i> {{$t('str.import-img')}}
              </div>
              <div>
                <b-row>
                  <b-col sm="12">
                    <h4 style="margin-bottom:0;">{{$t('str.mass-img-importer')}}</h4>
                    <span>{{$t('str.import-data-from-excel-file')}}</span><br /><br />
                    <b-form @submit.prevent="importImg">
                      <b-row class="form-group">
                        <b-col>
                          <b-form-file id="import_img" name="import_img" accept=".xlsx" :plain="true"
                            v-model="addDataImportImg.import_img" v-validate="{required:true}"></b-form-file>
                          <small>{{$t('str.only-xlsx-is-allowed')}}</small>
                          <b-alert show variant="danger" v-if="errors.first('import_img')">
                            {{$t('str.please-upload-file')}}
                          </b-alert>
                        </b-col>
                      </b-row>
                      <b-row class="form-group">
                        <b-col>
                          <b-button type="submit" variant="primary" class="px-4" :disabled="runningProcess"><i
                              v-if="runningProcess" class="fa fa-spinner fa-spin"></i>{{$t('str.import')}}</b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                    <b-alert show variant="warning" v-if="importImgTime != '00h 00m 00s'" v-html="importImgTime">
                    </b-alert>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
          <b-col sm="4">
            <b-card style="height:91.5%;">
              <div slot="header">
                <i class="fa fa-upload"></i> {{$t('str.export')}}
              </div>
              <div>
                <b-row>
                  <b-col sm="12">
                    <h4 style="margin-bottom:0;">{{$t('str.data-exporter')}}</h4>
                    <span>{{$t('str.export-existing-database-to-excel-format')}}</span><br /><br />
                    <b-form @submit.prevent="exportFile">
                      <b-row class="form-group">
                        <b-col>
                          <b-button type="submit" variant="primary" class="px-4" :disabled="runningProcess"><i
                              v-if="runningProcess" class="fa fa-spinner fa-spin"></i>{{$t('str.export-data')}}
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                    <b-form @submit.prevent="exportImg">
                      <b-row class="form-group">
                        <b-col>
                          <b-button type="submit" variant="primary" class="px-4" :disabled="runningProcess"><i
                              v-if="runningProcess" class="fa fa-spinner fa-spin"></i>{{$t('str.export-img')}}
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                    <b-alert show variant="warning" v-if="exportTime != '00h 00m 00s'" v-html="exportTime"></b-alert>
                    <b-button variant="success" class="px-4" v-if="exportFileLink" @click="downloadExportFile()">
                      Download File</b-button>
                    <b-button variant="success" class="px-4" v-if="exportImgLink" @click="downloadExportImg()">Download
                      File</b-button>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-card>
          <div slot="header">
            <i class="fa fa-bars"></i> {{$t('str.import-history')}}
            <div style="display:inline-block;">
              <b-form @submit.prevent="getAllImportHistory()">
                <b-input-group>
                  <b-form-input id="keyword" type="text" name="keyword" :placeholder="$t('str.search-filename')"
                    v-model="keyword" @keyup.enter="getAllImportHistory()"></b-form-input>
                  <b-input-group-append>
                    <buttons button-type="search" />&nbsp;
                    <buttons button-type="reset_filter" @click="resetFilter()" />
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </div>
          </div>
          <p :class="{'text-center':true, 'd-none':items.length}" class="">{{$t('str.no-data')}}</p>
          <b-table :class="{'d-none':!items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="status" slot-scope="data">
              <span v-if="data.item.status == 'success'" class="badge bg-success">Finished</span>
              <div class="spinner-border" role="status" v-if="data.item.status == 'processing'">
                <span class="sr-only">Loading...</span>
              </div>
              <span v-if="data.item.status == 'processing'" class="badge bg-secondary">Processing</span>
              <span v-if="data.item.status == 'failed'" class="badge bg-danger">Failed</span>
            </template>
            <template slot="filename" slot-scope="data">
              <a href="javascript:void(0)" @click="download(data.item.id, data.item.filename)">{{data.item.filename}}</a>
            </template>
            <template slot="elapsed" slot-scope="data">
              <span v-if="data.item.status == 'processing'">{{time}}</span>
              <span v-else>{{data.item.elapsed}}</span>
            </template>
            <template slot="log" slot-scope="data">
              <b-button variant="secondary" v-b-modal.log_modal @click="openLog(data.item)">Log</b-button>
            </template>
          </b-table>
          <nav :class="{'d-none':!items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>

    <log-modal :item="importItem"></log-modal>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
const fileDownload = require('js-file-download')

import Buttons from '@/views/component/Buttons'
import LogModal from '@/views/component/LogModal'

var importTimeBegan = null
  , importTimeStopped = null
  , importStoppedDuration = 0
  , importStarted = null
  , importRunning = false;
var importImgTimeBegan = null
  , importImgTimeStopped = null
  , importImgStoppedDuration = 0
  , importImgStarted = null
  , importImgRunning = false;
var exportTimeBegan = null
  , exportTimeStopped = null
  , exportStoppedDuration = 0
  , exportStarted = null
  , exportRunning = false;

export default {
  components: {
    'buttons': Buttons,
    'log-modal': LogModal,
  },
  data() {
    return {
      addDataImport: {
        table: '',
        import_file: '',
      },
      addDataImportImg: {
        import_img: ''
      },
      importFileSuccess: '',
      importFileError: '',
      exportFileSuccess: '',
      exportFileError: '',
      uploadImagesError: '',
      runningProcess: false,
      importTime: '00h 00m 00s',
      importImgTime: '00h 00m 00s',
      exportTime: '00h 00m 00s',
      exportFileLink: null,
      exportImgLink: null,
      logModal: false,
      importItem: {},
      currentImport: {},
      items: [],
      fields: [
        { key: 'id', sortable: true },
        { key: 'status' },
        { key: 'filename', sortable: true },
        {
          key: 'created_at', label: 'Started At', sortable: true, formatter: (value, key, item) => {
            let dateTime = new Date(item.created_at)
            dateTime = moment(dateTime).format("YYYY-MM-DD HH:mm:ss")
            return dateTime
          }
        },
        { key: 'elapsed', label: 'Elapsed time' },
        { key: 'log' },
      ],
      currentPage: 1,
      // perPage: 0,
      totalPage: 0,
      keyword: ''
    }
  },
  methods: {
    async importFile() {
      this.importFileSuccess = ''
      this.importFileError = ''
      this.$auth.checkSession()
      let validate = await this.$validator.validate('import_file', this.addDataImport.import_file)
      if (validate) {
        let method = 'post'
        let url = `${this.$helper.envi.VUE_APP_API_URL}/ImportTwoWheel/File`

        let formData = new FormData()
        if (this.addDataImport.import_file) {
          formData.append('import_file', this.addDataImport.import_file)
        }

        try {
          this.runningProcess = true
          let result = await axios[method](url, formData, {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })
          console.log(result.data)
          if (result.data.meta) {
            this.importFileSuccess = `<p>${result.data.meta.message}</p>`
            this.$toast.success(result.data.meta.message, '', {
              position: 'topCenter'
            })
          }
          this.getAllImportHistory()

          let prevStatus = ''

          let intervalStatus = setInterval(async () => {
            let loopResult = await axios['get'](`${this.$helper.envi.VUE_APP_API_URL}/ImportTwoWheel/Status`, {
              headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
            })

            if (loopResult.data.meta && prevStatus != loopResult.data.meta.message) {
              prevStatus = loopResult.data.meta.message
              this.importFileSuccess += `<p>${loopResult.data.meta.message}</p>`
            }

            if (loopResult.data.meta.message == 'Import finished' || loopResult.data.meta.message == 'Import failed') {
              console.log(loopResult.data)
              this.runningProcess = false
              clearInterval(intervalStatus)

              this.importStopTimer()
              let method = 'post'
              let url = `${this.$helper.envi.VUE_APP_API_URL}/ImportTwoWheel/UpdateHistory`

              let formData = {
                id: this.currentImport.id,
                elapsed: this.importTime,
              }
              if (loopResult.data.meta.message == 'Import failed') formData.status = 'failed'
              let result = await axios[method](url, formData, {
                headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
              })
              this.importResetTimer()
              this.getAllImportHistory()
            }
          }, 10000);
        } catch (e) {
          this.runningProcess = false
          console.log(e)
          if (typeof e.response !== 'undefined' || e.response.data.meta.error) {
            this.importFileError = `<p>${e.response.data.meta.error}</p>`
            this.$toast.error(e.response.data.meta.error, '', {
              position: 'topCenter'
            })
          } else {
            this.importFileError = `<p>Something went wrong. Probably the file is too long and it could not finish importing. Try divide the file into parts.</p>`
            this.$toast.error('Something went wrong. Probably the file is too long and it could not finish importing. Try divide the file into parts.', '', {
              position: 'topCenter'
            })
          }
          console.log(this.importFileError)
        }
      }
    },
    async importImg() {
      this.$auth.checkSession()
      let validate = await this.$validator.validate('import_img', this.addDataImportImg.import_img)
      if (validate) {
        let method = 'post'
        let url = `${this.$helper.envi.VUE_APP_API_URL}/ImportTwoWheel/Img`

        let formData = new FormData()
        if (this.addDataImportImg.import_img) {
          formData.append('import_img', this.addDataImportImg.import_img)
        }

        try {
          this.importImgStartTimer()
          let result = await axios[method](url, formData, {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

          if (result.data.meta) {
            this.importImgStopTimer()
            this.importImgResetTimer()
            this.$toast.success(result.data.meta.message, '', {
              position: 'topCenter'
            })
          }
        } catch (e) {
          if (e.response.meta.message == 'Error') {
            this.importImgResetTimer()
            this.$toast.error(e.response.meta.error, e.response.meta.message, {
              position: 'topCenter'
            })
          }
          console.log(e.response)
        }
      }
    },
    async exportFile() {
      this.exportFileSuccess = ''
      this.exportFileError = ''
      this.$auth.checkSession()

      let url = `${this.$helper.envi.VUE_APP_API_URL}/ExportTwoWheel`

      try {
        this.runningProcess = true
        this.exportStartTimer()
        let file = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        if (file.data) {
          this.exportFileLink = this.$helper.envi.VUE_APP_API_URL + '/' + file.data
          this.exportStopTimer()
        }
      } catch (e) {
        console.log(e)
        this.exportStopTimer()
        this.exportResetTimer()
      }
      console.log(this.exportTime)
      this.runningProcess = false
    },
    async downloadExportFile() {
      try {
        let open = window.open(this.exportFileLink)

        let delUrl = this.$helper.envi.VUE_APP_API_URL + '/ExportTwoWheel/DownloadFile/ItemSet'
        let delAuth = this.$auth.session.get().passport
        let timer = setInterval(async function () {
          if (open.closed) {
            clearInterval(timer)
            await axios.get(delUrl, {
              headers: { 'Authorization': `Bearer ${delAuth}` }
            })
            return true
          }
        }, 1000)
        if (timer) {
          this.exportFileLink = null
          this.exportResetTimer()
        }
      } catch (e) {
        console.log(e)
        this.exportResetTimer()
      }
    },
    async exportImg() {
      this.exportFileSuccess = ''
      this.exportFileError = ''
      this.$auth.checkSession()

      let url = `${this.$helper.envi.VUE_APP_API_URL}/ExportTwoWheel/ItemImg`

      try {
        this.runningProcess = true
        this.exportStartTimer()
        let file = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        if (file.data) {
          this.exportImgLink = this.$helper.envi.VUE_APP_API_URL + '/' + file.data
          this.exportStopTimer()
        }
      } catch (e) {
        console.log(e)
        this.exportStopTimer()
        this.exportResetTimer()
      }
      console.log(this.exportTime)
      this.runningProcess = false
    },
    async downloadExportImg() {
      try {
        let open = window.open(this.exportImgLink)

        let delUrl = this.$helper.envi.VUE_APP_API_URL + '/ExportTwoWheel/DownloadFile/ItemImg'
        let delAuth = this.$auth.session.get().passport
        let timer = setInterval(async function () {
          if (open.closed) {
            clearInterval(timer)
            await axios.get(delUrl, {
              headers: { 'Authorization': `Bearer ${delAuth}` }
            })
            return true
          }
        }, 1000)
        if (timer) {
          this.exportImgLink = null
          this.exportResetTimer()
        }
      } catch (e) {
        console.log(e)
        this.exportResetTimer()
      }
    },
    async getAllImportHistory(page) {
      this.$auth.checkSession()
      let trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/ImportTwoWheel/History${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].status == 'processing') {
            this.importStartTimer(this.items[i].created_at)
            this.currentImport = this.items[i]
            break
          }
        }
      } catch (e) {
        console.log(e.response)
        if (e.response) {
          this.$router.push('/pages/404')
        }
      }
    },
    async download(id, filename) {
      this.$auth.checkSession()
      try {
        let data = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/ImportTwoWheel/History/Download`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        await axios.get(this.$helper.envi.VUE_APP_API_URL + data.data.data + `?id=${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` },
          responseType: 'blob'
        }).then(res => {
          fileDownload(res.data, filename)
        })
      } catch (e) {
        console.log(e.response)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.getAllImportHistory()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getAllImportHistory(pageNum)
    },
    openLog(item) {
      this.$auth.checkSession()
      this.logModal = true
      this.importItem = item
    },
    closeLog() {
      this.$auth.checkSession()
      this.logModal = false
    },
    importStartTimer(from) {
      if (importRunning) return;

      if (importTimeBegan === null) {
        this.importResetTimer();
        importTimeBegan = new Date(from);
      }

      if (importTimeStopped !== null) {
        importStoppedDuration += (new Date() - importTimeStopped);
      }

      importStarted = setInterval(this.importClockRunning, 10);
      importRunning = true;
    },
    importStopTimer() {
      importRunning = false;
      importTimeStopped = new Date();
      clearInterval(importStarted);
    },
    importResetTimer() {
      importRunning = false;
      clearInterval(importStarted);
      importStoppedDuration = 0;
      importTimeBegan = null;
      importTimeStopped = null;
      this.importTime = "00h 00m 00s";
    },
    importClockRunning() {
      var currentTime = new Date()
        , timeElapsed = new Date(currentTime - importTimeBegan - importStoppedDuration)
        , hour = timeElapsed.getUTCHours()
        , min = timeElapsed.getUTCMinutes()
        , sec = timeElapsed.getUTCSeconds();

      this.importTime =
        this.zeroPrefix(hour, 2) + 'h ' +
        this.zeroPrefix(min, 2) + 'm ' +
        this.zeroPrefix(sec, 2) + 's';
    },
    importImgStartTimer() {
      if (importImgRunning) return;

      if (importImgTimeBegan === null) {
        this.importImgResetTimer();
        importImgTimeBegan = new Date();
      }

      if (importImgTimeStopped !== null) {
        importImgStoppedDuration += (new Date() - importImgTimeStopped);
      }

      importImgStarted = setInterval(this.importImgClockRunning, 10);
      importImgRunning = true;
    },
    importImgStopTimer() {
      importImgRunning = false;
      importImgTimeStopped = new Date();
      clearInterval(importImgStarted);
    },
    importImgResetTimer() {
      importImgRunning = false;
      clearInterval(importImgStarted);
      importImgStoppedDuration = 0;
      importImgTimeBegan = null;
      importImgTimeStopped = null;
      this.importImgTime = "00h 00m 00s";
    },
    importImgClockRunning() {
      var currentTime = new Date()
        , timeElapsed = new Date(currentTime - importImgTimeBegan - importImgStoppedDuration)
        , hour = timeElapsed.getUTCHours()
        , min = timeElapsed.getUTCMinutes()
        , sec = timeElapsed.getUTCSeconds();

      this.importImgTime =
        this.zeroPrefix(hour, 2) + 'h ' +
        this.zeroPrefix(min, 2) + 'm ' +
        this.zeroPrefix(sec, 2) + 's';
    },
    exportStartTimer() {
      if (exportRunning) return;

      if (exportTimeBegan === null) {
        this.exportResetTimer();
        exportTimeBegan = new Date();
      }

      if (exportTimeStopped !== null) {
        exportStoppedDuration += (new Date() - exportTimeStopped);
      }

      exportStarted = setInterval(this.exportClockRunning, 10);
      exportRunning = true;
    },
    exportStopTimer() {
      exportRunning = false;
      exportTimeStopped = new Date();
      clearInterval(exportStarted);
    },
    exportResetTimer() {
      exportRunning = false;
      clearInterval(exportStarted);
      exportStoppedDuration = 0;
      exportTimeBegan = null;
      exportTimeStopped = null;
      this.exportTime = "00h 00m 00s";
    },
    exportClockRunning() {
      var currentTime = new Date()
        , timeElapsed = new Date(currentTime - exportTimeBegan - exportStoppedDuration)
        , hour = timeElapsed.getUTCHours()
        , min = timeElapsed.getUTCMinutes()
        , sec = timeElapsed.getUTCSeconds();

      this.exportTime =
        this.zeroPrefix(hour, 2) + 'h ' +
        this.zeroPrefix(min, 2) + 'm ' +
        this.zeroPrefix(sec, 2) + 's';
    },
    zeroPrefix(num, digit) {
      var zero = '';
      for (var i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    }
  },
  created() {
    this.getAllImportHistory()
  }
}
</script>